import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

// Components
import Loader from './../utils/Loader';
import CheckoutSideSummary from './side-summary/CheckoutSideSummary';
import CheckoutMain from './CheckoutMain';

// State
import { getCart } from '../../store/actions/cart';

// CSS
import '../../css/checkout.css';

class Checkout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shoppertrack: '',
        };
    }

    componentWillReceiveProps(nextProps) {
        // console.log(nextProps);

        // ** Note: I had to use state here and NOT props, because props ended up not changing to nextProps immediately.
        // Why....? WHO KNOWS!
        if (
            !!nextProps.cart.shoppertrack &&
            this.state.shoppertrack !== nextProps.cart.shoppertrack
        ) {
            this.setState(
                {
                    shoppertrack: nextProps.cart.shoppertrack,
                },
                () => this.props.getCart()
            );
        }
    }

    render() {
        let title = 'Checkout';
        if (this.props.siteInfo.site) {
            title = this.props.siteInfo.site.title + ' | ' + title;
        }

        let helmet = (
            <Helmet>
                <title>{title}</title>
                <meta property="og:title" content={title} />
                <meta property="og:description" content={title} />
                <meta property="twitter:title" content={title} />
                {/* <script>
                    {`
                    gtag('event', 'conversion', {
                        'send_to': 'AW-366673725/hUVqCO7Cx6oYEL3-664B',
                        'value': 1.0,
                        'currency': 'USD',
                        'transaction_id': ''
                    });
                    `}
                </script> */}
            </Helmet>
        );

        const { persisted, items } = this.props;

        return (
            <main className="body_container container padded_top">
                {helmet}
                <h1>Checkout</h1>

                {!persisted ? (
                    <div className="pt2 pb2">
                        <Loader />
                    </div>
                ) : !items.length ? (
                    <div className="pb2">
                        You do not have any items in your shopping cart!
                    </div>
                ) : (
                    <div>
                        <CheckoutSideSummary />
                        <CheckoutMain />
                    </div>
                )}
            </main>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        persisted: state.persist,
        siteInfo: state.siteInfo,
        items: state.cart.items,
        cart: state.cart,
        stateTest: state,
    };
};

export default connect(
    mapStateToProps,
    { getCart }
)(Checkout);



// WEBPACK FOOTER //
// ./src/components/checkout/Checkout.js